import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Mail, Download, X } from "lucide-react";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

export default function AdminNewsletter() {
  const [subs, setSubs] = useState([]);
  const [total, setTotal] = useState(0);
  const reload = () => api.get("/admin/newsletter/subscribers").then((r) => { setSubs(r.data.subscribers || []); setTotal(r.data.total || 0); });
  useEffect(() => { reload(); }, []);

  const deactivate = async (id) => {
    if (!window.confirm("Disattivare questo iscritto?")) return;
    await api.delete(`/admin/newsletter/subscribers/${id}`);
    toast.success("Disattivato"); reload();
  };

  const exportCSV = () => {
    const header = "email,name,source,lang,active,created_at,consent_ts\n";
    const rows = subs.map((s) => [s.email, s.name || "", s.source || "", s.lang || "", s.active, s.created_at, s.consent_ts].join(","));
    const csv = header + rows.join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `newsletter-subscribers-${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const active = subs.filter((s) => s.active).length;
  const bySource = subs.reduce((acc, s) => ({ ...acc, [s.source || "unknown"]: (acc[s.source || "unknown"] || 0) + 1 }), {});

  return (
    <div data-testid="admin-newsletter-page">
      <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--accent))] font-semibold mb-2">Super Admin</div>
      <div className="flex flex-wrap items-start justify-between gap-4 mb-8">
        <div>
          <h1 className="editorial-heading text-4xl md:text-5xl">Newsletter</h1>
          <p className="text-muted-foreground mt-2">{active} iscritti attivi · {total} totali</p>
        </div>
        <Button data-testid="newsletter-export-csv" onClick={exportCSV} className="bg-[hsl(var(--primary))] gap-2">
          <Download className="h-4 w-4" /> Esporta CSV
        </Button>
      </div>

      {/* Sources */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
        {Object.entries(bySource).map(([src, count]) => (
          <div key={src} className="bg-card border border-border rounded-sm p-4">
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{src}</div>
            <div className="text-2xl font-bold mt-1">{count}</div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="bg-card border border-border rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-4 py-3">Email</th>
              <th className="text-left px-4 py-3">Nome</th>
              <th className="text-left px-4 py-3">Source</th>
              <th className="text-left px-4 py-3">Lingua</th>
              <th className="text-left px-4 py-3">Data iscrizione</th>
              <th className="text-left px-4 py-3">Stato</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {subs.map((s) => (
              <tr key={s.id} data-testid={`sub-${s.id}`} className="hover:bg-muted/30">
                <td className="px-4 py-3 font-medium">{s.email}</td>
                <td className="px-4 py-3">{s.name || "—"}</td>
                <td className="px-4 py-3"><span className="chip bg-muted">{s.source || "—"}</span></td>
                <td className="px-4 py-3 uppercase text-xs">{s.lang}</td>
                <td className="px-4 py-3 text-muted-foreground text-xs">{new Date(s.created_at).toLocaleDateString("it-IT")}</td>
                <td className="px-4 py-3">{s.active ? <span className="chip bg-green-100 text-green-900">Attivo</span> : <span className="chip bg-muted">Inattivo</span>}</td>
                <td className="px-4 py-3">{s.active && <button data-testid={`sub-delete-${s.id}`} onClick={() => deactivate(s.id)} className="text-destructive hover:opacity-70"><X className="h-4 w-4" /></button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {subs.length === 0 && <div className="py-20 text-center text-muted-foreground"><Mail className="h-10 w-10 mx-auto mb-3 opacity-40" />Nessun iscritto</div>}
      </div>
    </div>
  );
}
